export default "__VITE_ASSET__CmTZz84q__"